"use strict";
(self["webpackChunkclient"] = self["webpackChunkclient"] || []).push([[4335],{

/***/ 35957:
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"code":"en","resources":{"title":"Cookies!","text":"We use cookies in order to personalize your experience","nav":{"accept":"Accept","privacy":"Privacy Policy"}}}');

/***/ })

}]);